import React from "react";
import { Button } from "react-bootstrap";
import {
  IoIosArrowDown,
  IoIosArrowForward,
  IoIosCheckmarkCircleOutline,
} from "react-icons/io";
import moment from "moment/moment";
import { useCallback, useEffect, useState } from "react";
import apiPath from "../../Utils/apiPath";
import { apiGet } from "../../Utils/apiFetch";
import { debounce, isEmpty, startCase } from "lodash";
import InternalLoader from "../../component/InternalLoader";
import GameRecordFilter from "./GameRecordFilter";
import { FaCalendarAlt } from "react-icons/fa";
import { isLegacyEdge } from "react-device-detect";
import { formatWithCommas, toFixedWithoutRounding } from "../../Utils/Toast";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
const AccountRecord = () => {
  const [data, setData] = useState([]);
  const [listing, setListing] = useState([]);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [show, setShow] = useState({
    status: false,
    type: "",
  });
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    fromPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
    toPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
    type: "All",
  });
  const getData = async (obj = filter, type) => {
    const { status, data } = await apiGet(apiPath.accountStatement, {
      fromPeriod: moment(obj?.fromPeriod).format("YYYY-MM-DD"),
      toPeriod: moment(obj?.toPeriod).format("YYYY-MM-DD"),
      page: obj?.page,
      limit: obj?.limit,
    });
    if (status == 200) {
      if (data?.success) {
        setData(data?.results);
        if (type == "add") {
          setListing([...listing, ...data?.results?.data]);
        } else {
          setListing(data?.results?.data);
        }
      }
    }
    setLoader(false);
  };
  const handel = () => {
    setFilter({
      ...filter,
      page: filter?.page + 1,
    });
  };
  // Debounce wrapper to avoid multiple API calls
  const debouncedFetch = useCallback(
    debounce((obj) => {
      getData(obj);
    }, 500), // wait 600ms
    []
  );

  // Trigger API when filter changes but debounced
  useEffect(() => {
    setLoader(true);
    debouncedFetch(filter);
  }, [filter]);
  const format = "YYYY-MM-DD HH:mm:ss";
  const from = moment(filter?.fromPeriod);
  const to = moment(filter?.toPeriod);

  // 1️⃣ Check if both are today
  const isToday = from.isSame(moment(), "day") && to.isSame(moment(), "day");

  const setToday = () => {
    return {
      fromPeriod: moment().startOf("day").format(format),
      toPeriod: moment().endOf("day").format(format),
    };
  };

  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div className="mc-transaction-record-root mtrr-container">
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-record mc-default-header am-navbar am-navbar-light"
          >
            <div
              onClick={() => navigate(-1)}
              className="am-navbar-left"
              role="button"
            >
              <span className="am-navbar-left-content">
                <span className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">Account Record</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <div className="mc-filter-container name-filter">
          <div className="am-flexbox am-flexbox-align-middle mc-trans-filter  mc-filter ">
            <div className="am-flexbox am-flexbox-align-middle mc-trans-filter ">
              {/* <a
                onClick={() =>
                  setShow({
                    status: true,
                    type: "depositType",
                  })
                }
                role="button"
                className="am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                aria-disabled="false"
              >
                <IoIosArrowDown className="am-icon am-icon-down am-icon-xxs" />
                <span>All</span>
              </a> */}
              <a
                onClick={() =>
                  setFilter((prev) => {
                    return {
                      ...prev,
                      fromPeriod: setToday()?.fromPeriod,
                      toPeriod: setToday()?.toPeriod,
                    };
                  })
                }
                role="button"
                className={`am-button ${
                  isToday ? "am-button-primary" : "am-button-ghost"
                }  am-button-small am-button-inline am-button-icon`}
                aria-disabled="false"
                style={{ paddingRight: "0" }}
              >
                {isToday && (
                  <IoIosCheckmarkCircleOutline
                    size={16}
                    style={{ marginRight: "4px" }}
                  />
                )}
                <span>Today</span>
              </a>
              <div
                onClick={() =>
                  setShow({
                    status: true,
                    type: "range",
                  })
                }
                className="flex-shrink1 filter-time-btn"
              >
                <a
                  role="button"
                  className="am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                  aria-disabled="false"
                  style={{
                    "-webkit-flex": "0 0 50%",
                    "-ms-flex": "0 0 50%",
                    flex: "0 0 50%",
                  }}
                >
                  <FaCalendarAlt className="am-icon am-icon-calendar_c4db3b67 am-icon-xxs" />
                  <span>
                    {moment(filter?.fromPeriod).format("MM/DD")}-{" "}
                    {moment(filter?.toPeriod).format("MM/DD")}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="mc-trans-record-container name-filter">
          <div className="records-list-root">
            <ul
              className="scroll-inner-container"
              style={{ marginTop: "10px", paddingBottom: "0" }}
            >
              {data?.data?.length > 0 ? (
                data?.data?.map((res) => {
                  return (
                    <li>
                      <div className="rr-container">
                        <div className="tr-item-header">
                          <div
                            className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle"
                            style={{ height: "100%" }}
                          >
                            <div className="tr-item">
                              {/* <span className="record-icon-ticket" /> */}
                              <span className="tr-item-title">
                                {startCase(res?.gameType)}
                              </span>
                            </div>
                            <span
                              style={{ fontWeight: "600" }}
                              className="tr-item-time"
                            >
                              {moment(
                                res?.createdAt || res?.timeInserted
                              ).format("MM-DD hh:mm:ss")}
                            </span>
                          </div>
                        </div>
                        <div
                          style={{ background: "#f1efef" }}
                          className="tr-item-content"
                        >
                          <div className="tr-item-detail">
                            <div className="tr-item-content-item">
                              <div className="tic-code">
                                Type: {startCase(res?.betFaireType)}
                              </div>
                            </div>
                          </div>
                          <div className="tr-item-content-item tic-footer">
                            <div>
                              <span className="tic-footer-title number-mc">
                                Balance
                              </span>
                              <span className="tic-footer-amount number-mc">
                                {toFixedWithoutRounding(res?.amount)}
                              </span>
                            </div>
                            <div>
                              <span className="tic-footer-title number-mc">
                                Transaction amount
                              </span>
                              <span
                                className={`tic-footer-amount number-mc ${
                                  res?.transactionType === "credit"
                                    ? "color-green-in"
                                    : "color-red-in"
                                } `}
                              >
                                {res?.transactionType === "credit"
                                  ? toFixedWithoutRounding(res?.amount)
                                  : `(${toFixedWithoutRounding(
                                      Math.abs(res?.amount)
                                    )})`}
                              </span>
                            </div>
                          </div>
                          <div className="tr-item-detail">
                            <div className="tr-item-content-item">
                              <div
                                className="tic-code"
                                style={{ width: "100%", maxWidth: "100%" }}
                              >
                                Remark: {res?.remark || "-"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })
              ) : (
                <div
                  className="nodata-container"
                  style={{ height: "607.609px" }}
                >
                  <svg className="am-icon am-icon-nodata_f4c19c2d am-icon-md nodata-icon">
                    <use xlinkHref="#nodata_f4c19c2d" />
                  </svg>
                  <p className>No data</p>
                </div>
              )}

              {data?.hasNextPage && (
                <div
                  style={{
                    marginBottom: "40px",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    onClick={handel}
                    style={{
                      background: "black",
                      border: "none",
                      fontSize: "14px",
                      padding: "5px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    View More <IoIosArrowForward size={18} />
                  </Button>
                </div>
              )}
            </ul>
          </div>
        </div>
      </div>{" "}
      {show?.status && !isEmpty(show?.type) && (
        <GameRecordFilter
          type={show?.type}
          setFilter={setFilter}
          setShow={setShow}
          filter={filter}
        />
      )}
      {loader && <InternalLoader />}
    </div>
  );
};

export default AccountRecord;
